import script from "./ContentImagePicker.vue?vue&type=script&lang=ts&setup=true"
export * from "./ContentImagePicker.vue?vue&type=script&lang=ts&setup=true"

import "./ContentImagePicker.vue?vue&type=style&index=0&id=f5d77720&lang=scss&scoped=true"

import exportComponent from "/builds/intranet/intranet/vue/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f5d77720"]])

export default __exports__